/**
 * Sign-up password rules shared by the web/app form (yup) and the backend
 * register DTO (class-validator). Login never re-checks these, so older
 * accounts with shorter passwords keep working.
 */
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_RULES = [
    {
        key: "lowercase",
        pattern: /[a-z]/,
        message: "Password must have a small letter",
    },
    {
        key: "uppercase",
        pattern: /[A-Z]/,
        message: "Password must have a capital letter",
    },
    { key: "digit", pattern: /\d/, message: "Your password must have a number" },
    {
        key: "special",
        pattern: /[!@#$%^&*()\-_"=+{}; :,<.>]/,
        message: "Password must have a special character",
    },
];
/** Returns the keys of failed rules (plus 'minLength'); empty when valid. */
export function passwordRuleFailures(password) {
    if (typeof password !== "string") {
        return ["minLength"];
    }
    const failures = PASSWORD_RULES.filter((r) => !r.pattern.test(password)).map((r) => r.key);
    if (password.length < PASSWORD_MIN_LENGTH) {
        failures.push("minLength");
    }
    return failures;
}
export function isStrongSignupPassword(password) {
    return passwordRuleFailures(password).length === 0;
}
